import { makeStyles } from 'tss-react/mui';
import { PRODUCT_DETAILS_STICKY_HEADER_Z_INDEX } from '../../consts/productDetailsLayers.consts';

export const PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT = 40;

export const useProductDetailsScrollHeaderStyles = makeStyles()((theme) => ({
  rail: {
    position: 'sticky',
    top: 0,
    zIndex: PRODUCT_DETAILS_STICKY_HEADER_Z_INDEX,
    height: 0,
  },
  bar: {
    boxSizing: 'border-box',
    height: PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT,
    minWidth: 0,
    paddingInline: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    opacity: 0,
    pointerEvents: 'none',
    [theme.breakpoints.down('lg')]: {
      paddingInline: theme.spacing(1.5),
    },
  },
  barVisible: {
    opacity: 1,
    pointerEvents: 'auto',
  },
}));
